// Shared cohort vocabulary for the Heartbeats page: the raw metric
// dimensions (user_type × account_age × usage_tier) and the persona
// partition derived from them. The bubbles, timeline, sankey, and
// breakdown all speak this vocabulary so colors and labels stay in sync.

// Stack order + palette per cohort dimension (bottom band first).
export const GROUP_VALUES = {
  user_type: ['registered', 'guest'],
  account_age: ['established', 'new_7d'],
  usage_tier: ['casual', 'power'],
}

export const GROUP_COLORS = {
  registered: '#4e79a7',
  guest: '#f28e2c',
  established: '#59a14f',
  new_7d: '#e15759',
  casual: '#76b7b2',
  power: '#af7aa1',
}

export const GROUP_TITLES = {
  user_type: 'User Type',
  account_age: 'Account Age',
  usage_tier: 'Usage Tier',
}

export const VALUE_LABELS = {
  registered: 'Registered',
  guest: 'Guest',
  established: 'Established',
  new_7d: 'New (<7d)',
  casual: 'Casual',
  power: 'Power (>30 clips)',
}

// Persona partition of the 8 cohort combos — exclusive and exhaustive,
// so persona counts always sum to the headline total. NEW takes
// precedence over POWER for recently-signed-up heavy users (USER/POWER
// are defined as "older than 7 days").
export const PERSONAS = [
  {
    key: 'GUEST',
    color: '#f28e2c',
    legend: 'guest account',
    match: (c) => c.user_type === 'guest',
  },
  {
    key: 'NEW',
    color: '#e15759',
    legend: 'registered, signed up in the last 7 days',
    match: (c) => c.user_type === 'registered' && c.account_age === 'new_7d',
  },
  {
    key: 'USER',
    color: '#4e79a7',
    legend: 'registered, >7 days, ≤30 clips',
    match: (c) =>
      c.user_type === 'registered' &&
      c.account_age === 'established' &&
      c.usage_tier === 'casual',
  },
  {
    key: 'POWER',
    color: '#af7aa1',
    legend: 'registered, >7 days, >30 clips',
    match: (c) =>
      c.user_type === 'registered' &&
      c.account_age === 'established' &&
      c.usage_tier === 'power',
  },
]

// Visual stacking order (bottom first) for the blocks, stacked charts,
// and the bucket: POWER anchors the bottom as the steadiest and usually
// largest contributor, GUEST floats on top. Legends keep PERSONAS order.
export const STACK_ORDER = [...PERSONAS].reverse()
